export const defaultLang = "ua";
export const supportedLangs = {
  en: "English",
  ua: "Ukraine",
  ru: "Russian",
};
